module.exports = __webpack_public_path__ + "static/media/carta_38.cf300b2f.jpg";